export default __webpack_public_path__ + "static/media/new-task.91ed1fc3.wav";